import {
  Box,
  CircularProgress,
  FormControl,
  MenuItem,
  Select,
  Typography
} from "@mui/material";

import { useWizardStore } from "../../store/wizardStore";

interface SelectUserProps {
  users: string[];
  isLoadingUsers: boolean;
}

const SelectUser = ({ users, isLoadingUsers }: SelectUserProps) => {
  const { selectedUser, setSelectedUser } = useWizardStore();

  return (
    <Box>
      <Typography variant="subtitle1" gutterBottom>
        User
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        Select the team member to generate coaching insights for
      </Typography>
      <FormControl fullWidth>
        <Select
          value={selectedUser}
          onChange={(e) => setSelectedUser(e.target.value)}
          displayEmpty
          disabled={isLoadingUsers}
          startAdornment={isLoadingUsers ? <CircularProgress size={20} sx={{ mr: 1 }} /> : null}
        >
          <MenuItem value="" disabled>
            Select a user
          </MenuItem>
          {users.map((user) => (
            <MenuItem key={user} value={user}>
              {user}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
};

export default SelectUser;
